module.exports = __webpack_public_path__ + "static/img/7.b2a98a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/7.png
// module id = TPzd
// module chunks = 0